export { StickyStepper } from './StickyStepper'
export { Step } from './Step'
export { animations } from './animations'
export type { 
  StickyStepperProps, 
  StepProps, 
  AnimationFunction, 
  AnimationPresets 
} from './types'